import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import printWhite  from './../../img/white/print_white_24dp.svg';
import printBlack  from './../../img/black/print_black_24dp.svg';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button, Tabs, Tab} from 'react-bootstrap';

import ArajanlatTetelContent from './../../modules/ArajanlatTetel/ArajanlatTetelContent.js';
import MTOArajanlatTetelContent from './../../modules/MTOArajanlatTetel/MTOArajanlatTetelContent.js';
import ComboBoxInsertField from './../../components/ComboBoxInsertField';
import TextInsertField from './../../components/TextInsertField';
import CheckBoxInsertField from './../../components/CheckBoxInsertField';
import TextAreaInsertField from './../../components/TextAreaInsertField';
import DateInsertField from './../../components/DateInsertField';
import NumberInsertField from './../../components/NumberInsertField';
import ArengedmenyNumberField from './../../componentsSpecial/ArengedmenyNumberField';
import TextFormatter from './../../components/TextFormatter';
import ArajanlatUgyfelCombo from './../../componentsSpecial/ArajanlatUgyfelCombo';
import ArjanlatUgyfelCimCombo from './../../componentsSpecial/ArajanlatUgyfelCimCombo';
import ArajanlatSzallitasiCimCombo from './../../componentsSpecial/ArajanlatSzallitasiCimCombo';
import AjanlatUgyfelComboHozzaadassal from './../../componentsSpecial/AjanlatUgyfelComboHozzaadassal';
import RemoteDataDisplayField from './../../components/RemoteDataDisplayField';
import ArajanlatKalkulator from './ArajanlatKalkulator';

class ArajanlatInsert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            arajanlat_ugyfel_id: ''
            , arajanlat_monogram: ''

            , arajanlat_azonosito: ''
            , arajanlat_verzio: '0'
            , arajanlat_verzio2: '0'
            , arajanlat_projekt_vezeto_id: ''
            , arajanlat_projekt_vezeto_ajanlatra: ''
            , arajanlat_tervezo_ajanlatra: ''
            , arajanlat_tervezo_id: ''

            , arajanlat_ugyfel_cim_id: ''
            , arajanlat_szallitasi_cim_id: ''
            , arajanlat_targy: ''
            , arajanlat_leiras: ''
            , arajanlat_arengedmeny: '0'
            , arajanlat_datum: ''
            , arajanlat_datum_ervenyes: ''
            , arajanlat_hatarido: ''
            , arajanlat_garancia: ''
            , arajanlat_muszaki_leirasok: ''
            , arajanlat_megjegyzes: ''
            , arajanlat_nem_tartalmazza: ''

            , arajanlat_tulajdonos_id: ''
            , arajanlat_penznem_id: ''
            , arajanlat_hivatkozas_url: ''
            , arajanlat_szallitasi_mod_id: ''
            , arajanlat_fizetesi_feltetelek: ''
            , arajanlat_szulo_id: ''
            , arajanlat_legutolso: ''


            , ArajanlatTetel: []
            , MTOArajanlatTetel: []
            , arajanlat_promon: false
        }




        this.references = [];
        this.references['arajanlat_azonosito'] = React.createRef();
        this.references['arajanlat_ugyfel_id'] = React.createRef();
        this.references['arajanlat_monogram'] = React.createRef();

        this.references['arajanlat_verzio'] = React.createRef();

        this.references['arajanlat_projekt_vezeto_id'] = React.createRef();
        this.references['arajanlat_projekt_vezeto_ajanlatra'] = React.createRef();
        this.references['arajanlat_tervezo_ajanlatra'] = React.createRef();
        this.references['arajanlat_tervezo_id'] = React.createRef();

        this.references['arajanlat_ugyfel_cim_id'] = React.createRef();
        this.references['arajanlat_szallitasi_cim_id'] = React.createRef();
        this.references['arajanlat_targy'] = React.createRef();
        this.references['arajanlat_leiras'] = React.createRef();
        this.references['arajanlat_arengedmeny'] = React.createRef();
        this.references['arajanlat_datum'] = React.createRef();
        this.references['arajanlat_datum_ervenyes'] = React.createRef();
        this.references['arajanlat_hatarido'] = React.createRef();
        this.references['arajanlat_garancia'] = React.createRef();
        this.references['arajanlat_muszaki_leirasok'] = React.createRef();
        this.references['arajanlat_megjegyzes'] = React.createRef();
        this.references['arajanlat_nem_tartalmazza'] = React.createRef();
        this.references['arajanlat_ajanlat_keszito_id'] = React.createRef();
        this.references['arajanlat_tulajdonos_id'] = React.createRef();
        this.references['arajanlat_penznem_id'] = React.createRef();
        this.references['arajanlat_hivatkozas_url'] = React.createRef();
        this.references['arajanlat_szallitasi_mod_id'] = React.createRef();
        this.references['arajanlat_fizetesi_feltetelek'] = React.createRef();
        this.references['arajanlat_szulo_id'] = React.createRef();
        this.references['arajanlat_legutolso'] = React.createRef();
        this.references['arajanlat_MTO'] = React.createRef();
        this.references['arajanlat_MTO'] = React.createRef();
        this.references['arajanlat_promon'] = React.createRef();

        this.validators = [];
        this.validators['arajanlat_ugyfel_id'] = {fieldName: 'arajanlat_ugyfel_id', dataType: 'INT', value: this.state.arajanlat_ugyfel_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_monogram'] = {fieldName: 'arajanlat_monogram', dataType: 'VARCHAR', value: this.state.arajanlat_monogram, mandatory: false, min: null, max: null};

        this.validators['arajanlat_azonosito'] = {fieldName: 'arajanlat_azonosito', dataType: 'VARCHAR', value: this.state.arajanlat_azonosito, mandatory: false, min: null, max: null};
        this.validators['arajanlat_verzio'] = {fieldName: 'arajanlat_verzio', dataType: 'INT', value: this.state.arajanlat_verzio, mandatory: true, min: null, max: null};

        this.validators['arajanlat_projekt_vezeto_id'] = {fieldName: 'arajanlat_projekt_vezeto_id', dataType: 'INT', value: this.state.arajanlat_projekt_vezeto_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_projekt_vezeto_ajanlatra'] = {fieldName: 'arajanlat_projekt_vezeto_ajanlatra', dataType: 'TINYINT', value: this.state.arajanlat_projekt_vezeto_ajanlatra, mandatory: false, min: null, max: null};
        this.validators['arajanlat_tervezo_ajanlatra'] = {fieldName: 'arajanlat_tervezo_ajanlatra', dataType: 'TINYINT', value: this.state.arajanlat_tervezo_ajanlatra, mandatory: false, min: null, max: null};
        this.validators['arajanlat_tervezo_id'] = {fieldName: 'arajanlat_tervezo_id', dataType: 'INT', value: this.state.arajanlat_tervezo_id, mandatory: false, min: null, max: null};

        this.validators['arajanlat_ugyfel_cim_id'] = {fieldName: 'arajanlat_ugyfel_cim_id', dataType: 'INT', value: this.state.arajanlat_ugyfel_cim_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_szallitasi_cim_id'] = {fieldName: 'arajanlat_szallitasi_cim_id', dataType: 'INT', value: this.state.arajanlat_szallitasi_cim_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_targy'] = {fieldName: 'arajanlat_targy', dataType: 'VARCHAR', value: this.state.arajanlat_targy, mandatory: true, min: null, max: null};
        this.validators['arajanlat_leiras'] = {fieldName: 'arajanlat_leiras', dataType: 'VARCHAR', value: this.state.arajanlat_leiras, mandatory: false, min: null, max: null};
        this.validators['arajanlat_arengedmeny'] = {fieldName: 'arajanlat_arengedmeny', dataType: 'VARCHAR', value: this.state.arajanlat_arengedmeny, mandatory: true, min: null, max: null};
        this.validators['arajanlat_datum'] = {fieldName: 'arajanlat_datum', dataType: 'DATE', value: this.state.arajanlat_datum, mandatory: true, min: null, max: null};
        this.validators['arajanlat_datum_ervenyes'] = {fieldName: 'arajanlat_datum_ervenyes', dataType: 'DATE', value: this.state.arajanlat_datum_ervenyes, mandatory: true, min: null, max: null};
        this.validators['arajanlat_hatarido'] = {fieldName: 'arajanlat_hatarido', dataType: 'VARCHAR', value: this.state.arajanlat_hatarido, mandatory: false, min: null, max: null};
        this.validators['arajanlat_garancia'] = {fieldName: 'arajanlat_garancia', dataType: 'VARCHAR', value: this.state.arajanlat_garancia, mandatory: false, min: null, max: null};
        this.validators['arajanlat_muszaki_leirasok'] = {fieldName: 'arajanlat_muszaki_leirasok', dataType: 'VARCHAR', value: this.state.arajanlat_muszaki_leirasok, mandatory: false, min: null, max: null};
        this.validators['arajanlat_megjegyzes'] = {fieldName: 'arajanlat_megjegyzes', dataType: 'VARCHAR', value: this.state.arajanlat_megjegyzes, mandatory: false, min: null, max: null};
        this.validators['arajanlat_nem_tartalmazza'] = {fieldName: 'arajanlat_nem_tartalmazza', dataType: 'VARCHAR', value: this.state.arajanlat_nem_tartalmazza, mandatory: false, min: null, max: null};
        this.validators['arajanlat_tulajdonos_id'] = {fieldName: 'arajanlat_tulajdonos_id', dataType: 'INT', value: this.state.arajanlat_tulajdonos_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_penznem_id'] = {fieldName: 'arajanlat_penznem_id', dataType: 'INT', value: this.state.arajanlat_penznem_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_hivatkozas_url'] = {fieldName: 'arajanlat_hivatkozas_url', dataType: 'VARCHAR', value: this.state.arajanlat_hivatkozas_url, mandatory: false, min: null, max: null};
        this.validators['arajanlat_szallitasi_mod_id'] = {fieldName: 'arajanlat_szallitasi_mod_id', dataType: 'INT', value: this.state.arajanlat_szallitasi_mod_id, mandatory: true, min: null, max: null};
        this.validators['arajanlat_fizetesi_feltetelek'] = {fieldName: 'arajanlat_fizetesi_feltetelek', dataType: 'VARCHAR', value: this.state.arajanlat_fizetesi_feltetelek, mandatory: false, min: null, max: null};
        this.validators['arajanlat_szulo_id'] = {fieldName: 'arajanlat_szulo_id', dataType: 'INT', value: this.state.arajanlat_szulo_id, mandatory: false, min: null, max: null};
        this.validators['arajanlat_legutolso'] = {fieldName: 'arajanlat_legutolso', dataType: 'INT', value: this.state.arajanlat_legutolso, mandatory: false, min: null, max: null};
        this.validators['arajanlat_MTO'] = {fieldName: 'arajanlat_MTO', dataType: 'MTO', value: this.state.arajanlat_MTO, mandatory: false, min: null, max: null};
        this.validators['arajanlat_MTO'] = {fieldName: 'arajanlat_MTO', dataType: 'MTO', value: this.state.arajanlat_MTO, mandatory: false, min: null, max: null};

        this.validators['arajanlat_promon'] = {fieldName: 'arajanlat_promon', dataType: 'TINYINT', value: this.state.arajanlat_promon, mandatory: false, min: null, max: null};

        this.error = false;
        this.msg = "";
        this.load();

    }

    componentDidMount() {
        this.reset();
    }

    load = function () {

        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/Arajanlat/arajanlatInsertFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            self.setState({
                                'arajanlat_tulajdonos_id': response.data['arajanlat_tulajdonos_id'],
                                'arajanlat_penznem_id': response.data['arajanlat_penznem_id']
                            });
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        self.defaultUpdateBlocked = false;
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.defaultUpdateBlocked = false;
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.defaultUpdateBlocked = false;
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.defaultUpdateBlocked = false;
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    setFocusedComponent = function () {
        try {
            for (var i = 0; i < Object.keys(this.references).length; i++) {
                let first = Object.keys(this.references)[i];

                if (this.references[first].current != null && typeof this.references[first].current.focus != 'undefined') {
                    this.references[first].current.focus();
                    return false;
                }
            }
        } catch (e) {
            console.log("can not set focus on first component");
        }
    }

    reset = function () {
        this.setFocusedComponent();
        this.setState({arajanlat_ugyfel_id: ''
            , arajanlat_monogram: ''

            , arajanlat_azonosito: ''
            , arajanlat_verzio: '0'
            , arajanlat_verzio2: '0'
            , arajanlat_kapcsolattarto_id: ''
            , arajanlat_projekt_vezeto_id: ''
            , arajanlat_projekt_vezeto_ajanlatra: ''
            , arajanlat_tervezo_ajanlatra: ''
            , arajanlat_tervezo_id: ''

            , arajanlat_ugyfel_cim_id: ''
            , arajanlat_szallitasi_cim_id: ''
            , arajanlat_targy: ''
            , arajanlat_leiras: ''
            , arajanlat_arengedmeny: '0'
            , arajanlat_datum: ''
            , arajanlat_datum_ervenyes: ''
            , arajanlat_hatarido: ''
            , arajanlat_garancia: ''
            , arajanlat_muszaki_leirasok: ''
            , arajanlat_megjegyzes: ''
            , arajanlat_nem_tartalmazza: ''
            , arajanlat_tulajdonos_id: ''
            , arajanlat_penznem_id: ''
            , arajanlat_hivatkozas_url: ''
            , arajanlat_szallitasi_mod_id: ''
            , arajanlat_fizetesi_feltetelek: ''
            , arajanlat_szulo_id: ''
            , arajanlat_legutolso: ''
            , ArajanlatTetel: []
            , MTOArajanlatTetel: []
            , arajanlat_promon: false
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {

        var print = (this.props.theme == 'true') ? printWhite : printBlack;


        return <Container>
            <Row>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_azonosito')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    ----
                    </Col>
                </Row>
        
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_ugyfel_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <AjanlatUgyfelComboHozzaadassal 
                        id={'arajanlat_ugyfel_id'} 
                        value={this.state.arajanlat_ugyfel_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/ugyfel_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_ugyfel_id']}
                        editable={true}
                        theme={this.props.theme}
                        stateRef={this.state}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_ugyfel_cim_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <ArjanlatUgyfelCimCombo
                        id={'arajanlat_ugyfel_cim_id'} 
                        value={this.state.arajanlat_ugyfel_cim_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/ugyfel_cim_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_ugyfel_cim_id']}
                        editable={true}
                        theme={this.props.theme}
                        ugyfel_id={this.state.arajanlat_ugyfel_id}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_kapcsolattarto_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <RemoteDataDisplayField 
                        id={'arajanlat_kapcsolattarto_id'} 
                        value={this.state.arajanlat_ugyfel_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/getKapcsolattartoName.php'}
        
                        editable={false}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
        
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_szallitasi_cim_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <ArajanlatSzallitasiCimCombo 
                        id={'arajanlat_szallitasi_cim_id'} 
                        value={this.state.arajanlat_szallitasi_cim_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/szallitasi_cim_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_szallitasi_cim_id']}
                        editable={true}
                        theme={this.props.theme}
                        ugyfel_id={this.state.arajanlat_ugyfel_id}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>
                    {lang.getTitleBold('arajanlat_projekt_vezeto_id')}&nbsp;
                    <img 
                        src={print} 
                        onClick={() => {
                                        this.setState({arajanlat_projekt_vezeto_ajanlatra: (this.state.arajanlat_projekt_vezeto_ajanlatra == 0) ? 1 : 0});
                                    }}
                        />&nbsp;
                    <input type="checkbox" 
                           checked={(this.state.arajanlat_projekt_vezeto_ajanlatra == '1') ? true : false}
                           onClick={() => {
                                           this.setState({arajanlat_projekt_vezeto_ajanlatra: (this.state.arajanlat_projekt_vezeto_ajanlatra == 0) ? 1 : 0});
                                       }}
                           />
        
                    </Col>
                    <Col style={{textAlign: 'left'}}>
                    <ComboBoxInsertField 
                        id={'arajanlat_projekt_vezeto_id'} 
                        value={this.state.arajanlat_projekt_vezeto_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/projekt_vezeto_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_projekt_vezeto_id']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
        
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>
                    {lang.getTitleBold('arajanlat_tervezo_id')}&nbsp;
                    <img 
                        src={print} 
                        onClick={() => {
                                        this.setState({arajanlat_tervezo_ajanlatra: (this.state.arajanlat_tervezo_ajanlatra == 0) ? 1 : 0});
                                    }}
                        />&nbsp;
                    <input type="checkbox" 
                           checked={(this.state.arajanlat_tervezo_ajanlatra == '1') ? true : false}
                           onClick={() => {
                                           this.setState({arajanlat_tervezo_ajanlatra: (this.state.arajanlat_tervezo_ajanlatra == 0) ? 1 : 0});
                                       }}
                           />
        
                    </Col>
                    <Col style={{textAlign: 'left'}}>
                    <ComboBoxInsertField 
                        id={'arajanlat_tervezo_id'} 
                        value={this.state.arajanlat_tervezo_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/tervezo_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_tervezo_id']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3} >
                <Row >
                    <Col style={{textAlign: 'left'}}>
                    {lang.getTitleBold('arajanlat_promon')}&nbsp;
                    <input type="checkbox" 
                           checked={(this.state.arajanlat_promon == '1') ? true : false}
                           onChange={() => {
                                           this.setState({arajanlat_promon: (this.state.arajanlat_promon == 0) ? 1 : 0});
                                       }}
                           />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row>
                <Col md={12} style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_targy')}</Col>
                <Col md={12} style={{textAlign: 'left'}}>
                <TextInsertField 
                    id={'arajanlat_targy'} 
                    value={this.state.arajanlat_targy}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlat_targy']}
                    editable={true}
                    maxLength={255}
                    theme={this.props.theme}
                    style={{width: '100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                <Row>
                    <Col md={12} style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_datum_ervenyes')}</Col>
                    <Col md={12} style={{textAlign: 'left'}}>
                    <DateInsertField 
                        id={'arajanlat_datum_ervenyes'} 
                        value={this.state.arajanlat_datum_ervenyes}  
                        setBack={this.setBack.bind(this)}
                        reference={this.references['arajanlat_datum_ervenyes']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col md={12} style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_datum')}</Col>
                    <Col md={12} style={{textAlign: 'left'}}>
                    <DateInsertField 
                        id={'arajanlat_datum'} 
                        value={this.state.arajanlat_datum}  
                        setBack={this.setBack.bind(this)}
                        reference={this.references['arajanlat_datum']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_penznem_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <ComboBoxInsertField 
                        id={'arajanlat_penznem_id'} 
                        value={this.state.arajanlat_penznem_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/penznem_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_penznem_id']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col md={12} style={{textAlign: 'left'}}>
                    <ArengedmenyNumberField 
                        id={'arajanlat_arengedmeny'} 
                        value={this.state.arajanlat_arengedmeny}  
                        setBack={this.setBack.bind(this)}
                        reference={this.references['arajanlat_arengedmeny']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_statusz')}</Col>
                </Row>
                <Row>
                    <Col style={{textAlign: 'left'}}>ÁRAJÁNLAT</Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_hivatkozas_url')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <TextInsertField 
                        id={'arajanlat_hivatkozas_url'} 
                        value={this.state.arajanlat_hivatkozas_url}  
                        setBack={this.setBack.bind(this)}
                        reference={this.references['arajanlat_hivatkozas_url']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_tulajdonos_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <ComboBoxInsertField 
                        id={'arajanlat_tulajdonos_id'} 
                        value={this.state.arajanlat_tulajdonos_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/ajanlat_keszito_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_tulajdonos_id']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
        
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_szallitasi_mod_id')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <ComboBoxInsertField 
                        id={'arajanlat_szallitasi_mod_id'} 
                        value={this.state.arajanlat_szallitasi_mod_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/szallitasi_mod_idFormComboInsertData.php'}
                        reference={this.references['arajanlat_szallitasi_mod_id']}
                        editable={true}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
            </Row>
        
            <Row>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_verzio')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <TextInsertField 
                        id={'arajanlat_verzio'} 
                        value={this.state.arajanlat_verzio}  
                        setBack={this.setBack.bind(this)}
                        reference={this.references['arajanlat_verzio']}
                        editable={false}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
                </Col>
                <Col md={3}>
                <Row>
                    <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlat_monogram')}</Col>
                    <Col style={{textAlign: 'left'}}>
                    <RemoteDataDisplayField 
                        id={'arajanlat_monogram'} 
                        value={this.state.arajanlat_ugyfel_id}  
                        setBack={this.setBack.bind(this)}
                        dataSourceUrl={'modules/Arajanlat/getUgyfelMonogram.php'}
                        editable={false}
                        theme={this.props.theme}
                        />
                    </Col>
                </Row>
        
                </Col>
        
        
            </Row>
            <Tabs defaultActiveKey="arajanlat_leiras" id="tab_hatarido" className="mb-3">
                <Tab eventKey="arajanlat_leiras" title={lang.getTitleBold('arajanlat_leiras')} >
                    <Row>
                        <Col md={12}  style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_leiras'} 
                            kategoria_konstans={'LEIRAS'}
                            value={this.state.arajanlat_leiras}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_leiras']}
                            editable={true}   
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_hatarido" title={lang.getTitleBold('arajanlat_hatarido')}>
                    <Row>
                        <Col md={12} style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_hatarido'} 
                            kategoria_konstans={'HATARIDO'}
                            value={this.state.arajanlat_hatarido}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_hatarido']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_fizetesi_feltetelek" title={lang.getTitleBold('arajanlat_fizetesi_feltetelek')} >
                    <Row>
                        <Col md={12}  style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_fizetesi_feltetelek'} 
                            kategoria_konstans={'FIZETESI_FELTETELEK'}
                            value={this.state.arajanlat_fizetesi_feltetelek}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_fizetesi_feltetelek']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_garancia" title={lang.getTitleBold('arajanlat_garancia')} >
                    <Row>
                        <Col md={12}  style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_garancia'} 
                            kategoria_konstans={'GARANCIA'}
                            value={this.state.arajanlat_garancia}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_garancia']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_muszaki_leirasok" title={lang.getTitleBold('arajanlat_muszaki_leirasok')} >
                    <Row>
                        <Col md={12} style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_muszaki_leirasok'} 
                            kategoria_konstans={'MUSZAKI_LEIRAS'}
                            value={this.state.arajanlat_muszaki_leirasok}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_muszaki_leirasok']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_megjegyzes" title={lang.getTitleBold('arajanlat_megjegyzes')} >
                    <Row>
                        <Col md={12}  style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_megjegyzes'} 
                            kategoria_konstans={'MEGJEGYZES'}
                            value={this.state.arajanlat_megjegyzes}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_megjegyzes']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="arajanlat_nem_tartalmazza" title={lang.getTitleBold('arajanlat_nem_tartalmazza')} >
                    <Row>
                        <Col md={12}  style={{textAlign: 'left'}}>
                        <TextFormatter 
                            sablonKivalasztoval={true}
                            id={'arajanlat_nem_tartalmazza'} 
                            kategoria_konstans={'NEM_TARTALMAZZA'}
                            value={this.state.arajanlat_nem_tartalmazza}  
                            setBack={this.setBack.bind(this)}
                            reference={this.references['arajanlat_nem_tartalmazza']}
                            editable={true}
                            theme={this.props.theme}
                            />
                        </Col>
                    </Row>
                </Tab>
            </Tabs>
            <Row>
                <Col style={{minHeight: 150}}>
                &nbsp;
                </Col>
            </Row>
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                stateClone[property] = additionalParam[property];
            }
        }
        return stateClone;
    }

    insert = function (e) {

        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);

        if (validForm == false) {
            return false;
        }



        var method = e.target.id;
        var self = this;

        var params = this.concatAdditionalParams();

        try {
            const url = ajax.getUrlBase() + "modules/Arajanlat/arajanlatFormInsert.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify(params)
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            self.transactionSuccess();
                            if (method == 'save') {
                                self.closeForm();
                            }
                            if (method == 'save_new') {
                                self.reset();
                            }
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        self.state.defaultUpdateBlocked = false;
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.state.defaultUpdateBlocked = false;
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.state.defaultUpdateBlocked = false;
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.state.defaultUpdateBlocked = false;
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    getTabbedForm = function () {
        var form = this.getForm();

        return <Tabs defaultActiveKey="ajanlat" id="tab_insert" className="mb-3">
            <Tab eventKey="ajanlat" title={lang.getTitleBold('Arajanlat')}>
                {form}
            </Tab>
            <Tab eventKey="ajanlat_tetel" title={lang.getTitleBold('ArajanlatTetel')} >
        
                <MTOArajanlatTetelContent   
                    value={this.state.MTOArajanlatTetel} 
                    setBack={this.setBack.bind(this)} 
                    additionalParams={(typeof this.props.additionalParams == 'undefined') ? [] : this.props.additionalParams}
                    editable={true}
                    formType={(typeof this.props.formType == 'undefined') ? null : this.props.formType}
                    theme={this.props.theme}
                    arajanlat_arengedmeny={this.state.arajanlat_arengedmeny}
                    />
            </Tab>
        
        </Tabs>
    }

    render() {

        var form = this.getTabbedForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{minWidth: 1100, minHeight: '100%'}}>
            <div className={'popupWrapper' + className} id="ArajanlatInsert">
                <div  className={"popupHeader" + className} >
        
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('ArajanlatInsert')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
        
                <div  className={"popupFooter" + className} >
                    <ArajanlatKalkulator theme={this.props.theme} stateRef={this.state} />
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
        
        
        
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.insert.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('save')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default ArajanlatInsert;

